/**
 * The Debug section's paths, apart from its screens.
 *
 * `App.tsx` needs these to declare its redirects, and it must be able to do so
 * without importing `Debug.tsx` - that would pull all five incident screens
 * back into the entry chunk. `Debug.tsx` builds its sections FROM this list
 * (a record keyed by `DebugSlug`), so a slug with no screen, or a screen with
 * no slug, is a typecheck failure rather than a tab that goes nowhere.
 *
 * The slugs, in order - the first is what an unqualified `/debug` opens on.
 */
export const DEBUG_SLUGS = [
  'health',
  'dead-letter',
  'kill-switch',
  'audit',
  'scenario-runs',
] as const;

export type DebugSlug = (typeof DEBUG_SLUGS)[number];

/**
 * The slugs that were a TOP-LEVEL path before the grouping, and only those.
 *
 * `App.tsx` turns each into a redirect, so `/audit` still lands on
 * `/debug/audit` - an operator's bookmark and every link pasted into an
 * incident thread before the grouping. It is a hand-written list rather than
 * `DEBUG_SLUGS` because the two mean different things: this one is HISTORY and
 * is closed, while the other grows with every section added. Building the
 * redirects from all the slugs would have published `/scenario-runs` as a
 * top-level path that has never existed and that nothing can have bookmarked -
 * a redirect from nowhere, and one more path this portal answers on for no
 * reason. A section added from here gets no entry.
 */
export const DEBUG_LEGACY_SLUGS: readonly DebugSlug[] = [
  'health',
  'dead-letter',
  'kill-switch',
  'audit',
];
